<template>
    <div v-select-text="value" style="width: 800px; margin:0 auto; position: relative; border: 3px solid #efefef; padding: 20px;">
        <div style="font-size: 16px;">
            <p class="redline">
                Как мы знаем, время – это самый ценный ресурс, который у нас есть. Что же нужно делать, чтобы не быть придавленным обломками незавершенных дел? Один из самых лучших способов — научиться расставлять приоритеты.
            </p>
            <p class="redline">
                Это важное умение, потому что без него мы склонны идти по пути наименьшего сопротивления. Самые сложные, важные, неприятные дела отодвигаются на задний план. Между тем мы занимаемся чем-то веселым и легким. Это приводит к сильнейшему стрессу в итоге: падение самооценки, потеря самоуважения, осознание бесцельно проведенного времени.
            </p>
            <p class="redline">
                В качестве примера рассмотрим ситуацию на производстве.
            </p>
            <p class="redline">
                Два молодых специалиста-конструктора проявляли на новом рабочем месте высокую активность. Внешне ситуация выглядела вполне благополучно: они сосредоточенно смотрели в экран монитора, переговаривались по техническим вопросам, легко общались и помогали другим сотрудникам отдела. Однако статистический анализ показал, что ими было обработано наименьшее количество предоставленной конструкторской документации. Тогда руководство приняло решение провести «фотографию рабочего дня», где сотрудникам предлагалось фиксировать все, что они делали. Анализ выглядел примерно так: «Читал документацию, консультировался с Сидоровым, помог Николаю передвинуть стол, прочертил часть изделия, снова пытался разобраться в документации, посетил сайт Сидорова, потом искал листочек, на котором выполняли первоначальную прорисовку. Нашел, но понял, что ошибся и стал переделывать».
            </p>
            <p class="redline">
                Руководитель подразделения, отвечающий за обучение и развитие персонала, предложил отправить данных специалистов на обучение по программе управления временем (тайм-менеджменту). В результате конструкторами были освоены и успешно внедрены следующие навыки:
            </p>
            <ol style="margin-left: 40px;">
                <li>
                    Конструкторы стали группировать задачи и для каждой группы определять время. Например, с утра прорабатываю внешние характеристики изделий; с 11.00 до 13.00 вношу данные в компьютер и выполняю прорисовки; с 14.00 до 17.00 знакомлюсь с документацией по следующему изделию;
                    <br>
                </li>
                <li>
                    Они смогли научиться расставлять приоритеты и говорить «нет» (помочь коллеге, конечно, нужно, но не в ущерб работе и, тем более, исполнению чертежа).
                </li>
            </ol>
            <br>
            <p class="redline">
                Проведя анализ выполненных конструкторами проектов, спустя месяц после прохождения данного обучения, менеджеры смогли положительно оценить их работу.
            </p>
        </div>
    </div>
</template>
<script>
    import SelectText from '@/directives/select-text.js'

    export default {
        props: {
            value: [Array]
        },
        directives: {
            SelectText
        }
    }
</script>
<style scoped></style>